<template>
  <FilterLine
    v-if="prerenderMode"
    ref="filterLine"
  >
    <template #filters>
      <FilterDatesSkeleton>
        <FilterDates :is-scroll="isScroll" />
      </FilterDatesSkeleton>

      <FilterTourActivitiesSkeleton>
        <FilterTourActivities :is-scroll="isScroll" />
      </FilterTourActivitiesSkeleton>

      <FilterDurationSkeleton v-if="!isMobile">
        <FilterDuration :is-scroll="isScroll" />
      </FilterDurationSkeleton>

      <FilterPriceSkeleton v-if="!isMobile">
        <FilterPrice :is-scroll="isScroll" />
      </FilterPriceSkeleton>
    </template>

    <template #modal-button>
      <ModalFilter :is-scroll="isScroll" />
    </template>
  </FilterLine>
</template>

<script setup lang="ts">
  import { computed, ref } from 'vue';
  import FilterLine from './FilterLine.vue';
  import {
    FilterDatesSkeleton,
    FilterDates,
    FilterDurationSkeleton,
    FilterDuration,
    FilterTourActivitiesSkeleton,
    FilterTourActivities,
    FilterPriceSkeleton,
    FilterPrice,
  } from '@/features/filter';
  import ModalFilter from './ModalFilter.vue';
  import { useScreenSize } from '@experience/shared';
  import { getBootstrapData } from '@experience/core-hostapp-share-lib';

  interface FilterLineExpose {
    isScroll: boolean;
    isOverlowFilterScroll: boolean;
    isShowGradient: boolean;
  }
  const filterLine = ref<FilterLineExpose | null>(null);

  const isScroll = computed(() => filterLine.value?.isScroll ?? false);

  const { isMobile } = useScreenSize();

  const prerenderMode = computed(() => getBootstrapData().prerenderMode);
</script>
